export enum forgotEmailStep {
    initial,
    verificationCode,
    emailNotVerified,
    success,
}

export interface IVerificationCodeApi {
    otpUuid: string;
}

export interface IRecoverEmailApi {
    email: string;
    isVerified: boolean;
    validOtp: boolean;
}
